import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation_types'
import ProductService from './product_service'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// mutations
const mutations = {

    [types.ADD_TO_CART] (state, { id, order_code, discount, note, price, fullprice, quantity }) {
        const record = state.cart.find(p => p.order_code === order_code, p => p.discount === discount)

        if (!record) {
            state.cart.push({
                order_code: order_code,
                quantity: quantity,
                discount: discount,
                price: price,
                fullprice: fullprice,
                note: note,
                id: id
            })
        } else {
            record.quantity = quantity;
        }
    },
    [types.ITEM_NOTE] (state, { id, order_code, discount, note }) {
        const record = state.cart.find(p => p.order_code === order_code, p => p.discount === discount)

        if (record) {
            record.note = note;
        }
    },
    [types.UPDATE_CART] (state, items) {
        state.cart = items.map((e) => {
            return {
                order_code: e.order_code,
                quantity: e.quantity,
                discount: e.discount,
                price: e.price,
                fullprice: e.fullprice,
                note: e.note,
                id: e.id,
            };
        });
    },
    [types.EMPTY_CART] (state) {
        state.cart = []
    },
    ORDER_NUMBER(state, order_number) {
        state.order_number = order_number
    },
    DISCOUNT_CODE(state, discount_code) {
        state.discount_code = discount_code
    },
    [types.REMOVE_FROM_CART] (state, { order_code }) {
        const newState = state.cart.filter(p => p.order_code !== order_code)
        state.cart = newState
    },
}
// initial state
const state = {
    cart: [],
    cartLoaded: false,
    order_number: 0,
    discount_code: '',
    note: '',
}

// getters
const getters = {
    cart: state => {
        return state.cart;
    },
    orderNumber: state => {
        return state.order_number;
    },
    cartSize: state => {
        return state.cart.length;
    },
}

// actions
const actions = {
    // Cart getter for display, additional metadata & translated name
    getCart({ commit }){
        return new Promise((resolve, reject) => {
            // Do something here... lets say, a http call using vue-resource
            window.axios("/api/cart")
                .then(response => {
                    if(response.data.items.length > 0) {
                        document.getElementById('shopping-cart-icon').className = 'fa fa-cart-plus';
                        document.getElementById('shopping-cart-badge').style.display = 'block';
                        document.getElementById('shopping-cart-badge').textContent = response.data.items.length;
                    }
                    // else {
                    //     document.getElementById('shopping-cart-icon').className = 'fa fa-shopping-cart';
                    //     document.getElementById('shopping-cart-badge').style.display = 'none';
                    // }
                    resolve(response);  // Let the calling function know that http is done. You may send some data back
                }, error => {
                    reject(error);
                })
        });
    },

    addToCart({ commit, dispatch }, product){

        // Submit changes to server for it to store in session
        window.axios.post('/api/add_cart/0', {
            id: product.id,
            order_code: product.order_code,
            discount: product.discount,
            price: product.discount_price,
            fullprice: product.price,
            quantity: product.quantity,
            note: product.note,
        }).then((response)=>{
            commit(types.ADD_TO_CART, {
                id: response.data.item.id,
                order_code: response.data.item.order_code,
                discount: response.data.discount,
                note: response.data.note,
                price: response.data.discount_price,
                fullprice: product.price,
                quantity: response.quantity,
            });

            $('#order-gratis-product .limit-2500').hide();
            $('#order-gratis-product .limit-3000').hide();
            $('#order-gratis-product .limit-below').hide();

            dispatch('getCart');
        });
    },
    removeFromCart({ commit }, product){

        // Submit changes to server for it to store in session
        window.axios.post('/api/remove_cart/0', {
            order_code: product.order_code,
        }).then((response)=>{
            commit(types.REMOVE_FROM_CART, {
                order_code: product.order_code
            });
        });
    },
    emptyCart({ commit, dispatch }){
        // Submit changes to server for it to store in session
        window.axios.get('/api/clear_cart')
            .then((response)=>{
                commit(types.EMPTY_CART);
                this.cart = [];
                document.getElementById('shopping-cart-icon').className = 'fa fa-shopping-cart';
                document.getElementById('shopping-cart-badge').style.display = 'none';
                //dispatch('getCart');
            });
    },
    setItemNote({ commit, dispatch }, product){
        // Submit changes to server for it to store in session
        window.axios.post('/api/add_note', {
            id: product.id,
            order_code: product.order_code,
            discount: product.discount,
            price: product.discount_price,
            fullprice: product.price,
            quantity: product.quantity,
            note: product.note
        }).then((response)=>{
            commit(types.ITEM_NOTE, {
                id: response.data.item.id,
                order_code: response.data.item.order_code,
                discount: response.data.discount,
                note: response.data.note
            });
        });
    },
    setDiscountCode({ commit, dispatch }, discountCode){
        // Submit changes to server for it to store in session
        window.axios.post('/api/add_discount_code', {
            discountCode: discountCode
        }).then((response)=>{
            commit(types.DISCOUNT_CODE, {
                discountCode: response.discount_code
            });
        });
    },
    setOrderNum({ commit }, order_number){
        commit('ORDER_NUMBER', order_number)
    },
}

// one store for entire application
export default new Vuex.Store({
    state,
    strict: debug,
    getters,
    actions,
    mutations,
    plugins: [createPersistedState()],
})
